import {
  Row,
  Column,
  Container,
  Loader,
  Heading,
  ActionBar,
  withSession,
  sessionShape,
  useUser,
  useApi,
} from "lcm-iot-commons";
import { useIntl } from "react-intl";
import EditPictures from "lcm-iot-commons/client/lib/components/Pictures/EditPictures";
import { useParams } from "react-router-dom";
import ProductForm from "./ProductForm";

type Props = {
  session: sessionShape;
};

export function ProductEdit({ session }: Props) {
  const intl = useIntl();
  const user = useUser();
  // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type '{}'.
  const { id } = useParams();
  const api = useApi();

  const { data, isLoading } = api.get.useQuery(`/products/${id}`, {
    include: "status,tenant,parent,manufacturer,categories.parent",
  });
  const initialValues = data
    ? {
        id: (data as $TSFixMe).id,
        tenant: {
          id: (data as $TSFixMe).tenant.id,
          name: (data as $TSFixMe).tenant.name,
        },
        manufacturer: {
          id: (data as $TSFixMe).manufacturer.id,
          name: (data as $TSFixMe).manufacturer.name,
        },
        code: (data as $TSFixMe).product_code,
        name: (data as $TSFixMe).name,
        description: (data as $TSFixMe).description,
        status: {
          id: (data as $TSFixMe).status.id,
          name: (data as $TSFixMe).status.name,
        },
        parent: (data as $TSFixMe).parent
          ? {
              id: (data as $TSFixMe).parent?.id,
              name: (data as $TSFixMe).parent?.name,
            }
          : null,
        category:
          (data as $TSFixMe).categories.length > 0
            ? (data as $TSFixMe).categories[0]
            : null,
        riskOfMaintainability: (data as $TSFixMe).risk_of_maintainability,
      }
    : null;

  return (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            <Heading
              id="edit-header"
              title={intl.formatMessage({ id: "product_edit.header" })}
            />
          </ActionBar>
        </Column>
      </Row>
      <Row>
        <Column lg="7">
          <Heading
            id="edit-details"
            title={intl.formatMessage({ id: "product_edit.details" })}
            level={2}
          />
          {initialValues && (
            <ProductForm
              id="edit-product"
              fetching={isLoading}
              // @ts-expect-error TS(2322) FIXME: Type '{ id: any; tenant: { id: any; name: any; }; ... Remove this comment to see the full error message
              initialValues={initialValues}
              edit
            />
          )}
        </Column>
        <Column lg="5">
          {initialValues?.id && (
            <EditPictures
              // @ts-expect-error TS(2322) FIXME: Type '{ id: string; model: string; modelId: any; p... Remove this comment to see the full error message
              id="edit-pictures"
              model="products"
              modelId={initialValues.id}
              placeholder="lcm-iot-icon-product"
              user={user}
              session={session}
            />
          )}
        </Column>
      </Row>
      <Loader loading={isLoading} />
    </Container>
  );
}

export default withSession(ProductEdit);
